module.exports = __webpack_public_path__ + "img/water-lily-640.817750ad.jpg";